import { app } from '../../../bootstrap/core';
import { inputFormComponent } from './inputForm.component';
import { InputFormService } from './inputForm.service';
import './standingOrderForm/standingOrderForm';
import './receivedPaymentForm/receivedPaymentForm';
import './directDebitForm/directDebitForm';
import './passwordForm/passwordForm';

app.component('inputForm', inputFormComponent);
app.service('inputFormService', InputFormService);
